"use strict";
/* istanbul ignore file */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Login = void 0;
class Login {
    constructor(authService) {
        this.authService = authService;
    }
    execute(request) {
        const { config } = request;
        return this.authService.login(config);
    }
}
exports.Login = Login;
